export default () => ({
    categorias: [],
    activeMenu: 'Home',
    isLoading: true,
    tasa: '',
    conf: ''
})